
<div class="header-toolbar">
  <h1>{{ title }}</h1>
</div>

<div *ngIf="execution">

  <!-- Toolbar -->
  <div class="main btn-toolbar">
        
    <button class="btn" (click)="applyFilter()" *ngIf="selectedLinks.length > 0 && !selectedOperation">
      <t-icon name="search"></t-icon>
      <span class="text">Filtrer les opérations</span>
    </button>

    <button class="btn" (click)="cancel()" *ngIf="selectedLinks.length > 0 && selectedOperation">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </button>

  </div>
  <!-- /Toolbar -->

  <div class="grid">

    <div class="column">

      <div class="panel">
        <h2>
          Données
          <span style="font-size: 14px; color: #383838;">({{ selectedLinks.length }} enregistrements sélectionnés)</span>
        </h2>

        <t-select-tree [dossier]="dossier" [dossierModel]="dossierModel" [(selectedLinks)]="selectedLinks"></t-select-tree>

      </div>
      
    </div>

    <div class="column">

      <div class="panel" *ngIf="selectedLinks.length === 0">
        <div class="empty-table compact">
          <p>Veuillez sélectionner des enregistrements</p>
        </div>
      </div>

      <t-select-operation [hidden]="selectedLinks.length === 0 || selectedOperation" [(selectedOperation)]="selectedOperation" [(showFilter)]="showOperationFilter"></t-select-operation>

      <t-select-revision *ngIf="selectedLinks.length > 0 && selectedOperation && !selectedRevision" [operation]="selectedOperation" [(selectedRevision)]="selectedRevision"></t-select-revision>

      <t-select-root-fields *ngIf="selectedLinks.length > 0 && selectedOperation && selectedRevision" [operation]="selectedOperation" [revision]="selectedRevision" (selected)="save($event)"></t-select-root-fields>

    </div>

  </div>
</div>